import Phaser from "phaser";
import LoadingScene from "@/games/Mining/scenes/LoadingScene";
import RoundStartScene from "@/games/Mining/scenes/RoundStartScene";
import QuestionScene from "@/games/Mining/scenes/QuestionScene";
import PlayScene from "@/games/Mining/scenes/PlayScene";
import BossScene from "@/games/Mining/scenes/BossScene";
import Settings from "@/games/Mining/scenes/Settings";
import LandingScene from "@/games/Mining/scenes/LandingScene";

function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      RoundStartScene,
      QuestionScene,
      PlayScene,
      BossScene,
      Settings,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
